<template>
  <div class="app-body">
    <v-layout v-if="showDownload" justify-space-between>
      <v-spacer>
        <div v-if="showBodyInfo" class="body-info">
          <img :src="require('@/assets/info.svg')" />
          <span class="body-info-text">Os dados deste relatório são atualizados em até 2 dias desde que não haja interrupção na integração entre os sistemas.</span>
        </div>
      </v-spacer>

      <v-btn @click="onDownload" v-if="!$isMobile()" flat>
        <i class="material-icons">get_app</i>
        Download
      </v-btn>
    </v-layout>

    <v-layout v-if="showExport" justify-space-between>
      <v-spacer>
        <span class="body-info-text"></span>
      </v-spacer>
      <v-btn @click="onExport" v-if="!$isMobile()" flat>
        <i class="material-icons">get_app</i>
        Exportar
      </v-btn>
    </v-layout>

    <AppList v-if="$isMobile() && activeMobileList" v-bind="$attrs" v-on="$listeners" />

    <AppTable v-else v-bind="$attrs" v-on="$listeners" />
  </div>
</template>

<script>
import AppTable from '@/components/ui/AppTable'
import AppList from '@/components/ui/AppList'
import { biRequests } from '@/services/containers/app/main'

export default {
  name: 'AppBody',
  components: {
    AppTable,
    AppList
  },
  props: {
    download: {
      type: Object,
      default: () => ({ report: '', jobId: '' })
    },
    export: {
      type: Object,
      default: () => ({ report: '', jobId: '', filters: {}})
    },
    currentQuery: {
      type: String,
      default: () => null
    },
    activeMobileList: {
      type: Boolean,
      default: () => true
    },
    forceDownload: {
      type: Boolean,
      default: () => false
    },
    showBodyInfo: {
      type: Boolean,
      default: () => false
    },
  },
  methods: {
    async onDownload() {
      if (this.download === 'emit' || this.download.report === 'emit') {
        this.$emit('onDownload')
        return
      }

      try {
        this.$showLoading()
        await biRequests(this.download, this.currentQuery)
        this.$toast('A solicitação de exportação foi criada', 'green')
      } catch (err) {
        this.$toast('Falha ao solicitar exportação', 'red')
      } finally {
        this.$hideLoading()
      }
    },
    async onExport() {
      if (this.export === 'emit' || this.export.report === 'emit') {
        this.$emit('onExport')
        return
      }

      try {
        this.$showLoading()
        await biRequests(this.export, this.currentQuery)
        this.$toast('A solicitação de exportação foi criada', 'green')
      } catch (err) {
        this.$toast('Falha ao solicitar exportação', 'red')
      } finally {
        this.$hideLoading()
      }
    }
  },
  computed: {
    hasDownload() {
      return this.download && this.download.report
    },
    hasExport() {
      return this.export && this.export.report
    },
    anonymizeParticipants() {
      return this.$store.getters.getUser?.modules?.general?.anonymizeParticipants
    },
    showDownload() {
      const show = (this.hasDownload && !this.anonymizeParticipants) || this.forceDownload
      const isDataLoaded = !!this.download?.jobId
      return show && isDataLoaded
    },
    showExport() {
      const show = (this.hasExport && !this.anonymizeParticipants) || this.forceExport
      return show
    }
  }
}
</script>

<style lang="stylus" scoped>
.app-body
  margin-top: 20px

.body-info
  background: rgba(0, 0, 0, 0.08);
  border-radius: 5px
  height: 40px;
  padding: 10px 0 0 13px;
  margin-left: 10px;
  display: flex;
  align-items: flex-start;
  width: 800px;

.body-info-text
  margin-left: 10px
</style>
